<template>
  <div class="sbk-steps">
    <div
      v-for="(t, index) in values"
      :key="index"
      :class="'sbk-steps-item ' + status(index)"
    >
      <div :class="'sbk-steps-item-icon' + status(index)">
        <div :class="'sbk-steps-item-content' + status(index)">
          {{ t }}
          <i v-if="index + 1 !== values.length" class="iconfont icon-you"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    current: {
      type: Number,
      default: 0,
    },
    values: {
      type: Array,
      default: [],
    },
  },
  computed: {
    status() {
      return function(index) {
        const _crt = parseInt(this.current) ? parseInt(this.current) : 0
        const _length = this.values.length
        const _current = _crt < 0 ? 0 : _crt > _length - 1 ? _length - 1 : _crt
        return index > _current
          ? 'wait'
          : index === _current
          ? 'active'
          : 'finish'
      }
    },
  },
}
</script>
<style lang="less">
// .iconfont {
//   font-size: 12px;
//   position: absolute;
//   top: 0px;
//   right: -30%;
//   display: inline-block;
//   color: rgba(120, 140, 162, 1);
// }
.sbk-steps {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 500px;
  height: 33px;
  line-height: 33px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  font-size: 14px;
  &-item {
    // width: 33.3%;
    position: relative;
    height: 100%;
    text-align: center;
    padding: 0 10px;
    // &:not(:last-child)::after {
    //   content: 'ㄍ';
    //   position: absolute;
    //   top: 0px;
    //   right: -30%;
    //   display: inline-block;
    //   // width: 30%;
    //   color: rgba(120, 140, 162, 1);
    //   transform: rotate(180deg);
    // }
    .iconfont {
      font-size: 12px;
      position: absolute;
      top: 0px;
      right: -30%;
      display: inline-block;
      color: rgba(120, 140, 162, 1);
    }
    
    &-icon {
      color: #fff;
      font-size: 14px;
      text-align: center;
      border-radius: 16px;
      position: relative;
    }
    &-content {
      font-size: 14px;
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
      text-align: center;
    }
    &.active {
      background: #6380eb;
      border: 1px solid #5575e9;
      border-radius: 17px;
      padding: 0 20px;
      color: #fefeff;
    }
    &.finish {
      color: rgba(120, 140, 162, 1);
    }
    &.wait {
      color: #788ca2;
      border: none;
    }
  }
}
</style>
